// src/stockx/base/CompanyIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx } from "react/jsx-runtime";
var CompanyIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsx(Icon, { viewBox: "0 0 50 50", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M27.61 31.75L40.76 43.01V34.01L30.25 25.01L40.76 15.99V6.98999L22.39 22.74V18.25L9.23999 6.98999V15.99L19.75 24.99L9.23999 34.01V43.01L27.61 27.26V31.75Z",
    fill: colorized ? "#006340" : "currentColor"
  }
) });
var CompanyIcon_default = CompanyIcon;

export {
  CompanyIcon_default
};
